module.exports = __webpack_public_path__ + "band_4.f2a3182f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_4.png
// module id = xKHD
// module chunks = 0